import {Button, Descriptions, Divider, Drawer} from "antd";
import React from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

const DrawerTradePoint = (props) => {
    const {t} = useTranslation()

    return (
        <>
            <Drawer title={t('trade_point')}
                    placement="right"
                    closable={true}
                    onClose={() =>props.setShow(false)}
                    getContainer={false}
                    visible={props.show}
                    width={500}
                    extra={
                        <Link to={'site/trade-points/trade-point'}
                              state={{id: props.trade_point.id}}>
                            <Button>{t('more')}</Button>
                        </Link>
                    }>

                <Descriptions>

                    <Descriptions.Item label={t('code')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.trade_point_code}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('name')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.name}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('address')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.address}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('legal_entity')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.legal_entity}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('legal_address')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.legal_address}</span>
                    </Descriptions.Item>

                </Descriptions>

                <Divider />

                <Descriptions>

                    <Descriptions.Item label={t('geography')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.geography}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('branch')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.branch}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('type')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.type}</span>
                    </Descriptions.Item>

                    <Descriptions.Item label={t('chain')} span={3}>
                        <span style={{fontFamily: 'Montserrat-Medium'}}>{props.trade_point.chain}</span>
                    </Descriptions.Item>

                </Descriptions>

                <Divider />

            </Drawer>
        </>
    )
}

export default DrawerTradePoint